<template>
  <div v-if="shelfConfig && shelfConfig.length" :class="['swiper-container--banner', className]">
    <swiper ref="serviceZoneAdsSwiper" :options="swiperOption" class="swiper-wrapper">
      <swiper-slide
        v-for="(item, index) in shelfConfig"
        :key="index"
        :class="[
          'swiper-slide',
          'list-top-banner-info',
          item.price ? 'list-top-banner-info--type4' : '',
          !item.subTitle ? 'list-top-banner-info--type5' : '',
          !(item.subTitle || item.mainTitle || item.description) ? 'no-mask' : ''
        ]"
        :style="'background-image:url(' + item.url + ')'"
      >
        <!-- 月卡样式 -->
        <template v-if="item.price">
          <h4 class="banner-info-title">{{ item.mainTitle }}</h4>
          <p class="banner-info-tips">{{ item.subTitle }}</p>

          <div class="banner-info-tips-box">
            <p class="banner-info-value">{{ item.price }}</p>
          </div>
        </template>
        <template v-else>
          <p v-if="item.subTitle" class="banner-info-tips">{{ item.subTitle }}</p>
          <h4 class="banner-info-title">{{ item.mainTitle }}</h4>
          <div class="banner-info-tips-box">
            <p class="banner-info-tips">{{ item.description }}</p>
          </div>
        </template>
      </swiper-slide>
      <div slot="pagination" class="swiper-pagination"></div>
    </swiper>
  </div>
</template>

<script>
/**
 * 广告位货架，用于列表页（分店列表页，商店游戏列表页）的顶部
 */
import { swiper, swiperSlide } from "vue-awesome-swiper"
import { mapActions } from "vuex"
import * as reportDict from "@constants/report-dictonary"
import gameServiceZoneMixin from "../../mixins/gameServiceZone"

let vm = null
export default {
  name: "ActivityShelf",
  components: {
    swiper,
    swiperSlide
  },
  mixins: [gameServiceZoneMixin],
  props: {
    shelfConfig: Array,
    pfStructure: {
      type: String,
      default: ""
    },
    className: {
      type: String,
      default: ""
    },
    jumpToBuyPageFunc: {
      type: [Function, String],
      default: ""
    }
  },
  computed: {
    // swiper配置
    swiperOption() {
      return {
        loop: this.shelfConfig && this.shelfConfig.length > 1,
        spaceBetween: 16,
        autoplay: this.shelfConfig && this.shelfConfig.length > 1 ? { delay: 3000, disableOnInteraction: false } : false,
        pagination: {
          el: ".swiper-pagination"
        },
        on: {
          click: function () {
            if (vm) vm.jumpToBuyPage(this.realIndex)
          }
        },
        preventLinksPropagation: false
      }
    }
  },
  mounted() {
    vm = this
  },
  deactivated() {
    this.$refs.serviceZoneAdsSwiper &&
      this.$refs.serviceZoneAdsSwiper.swiper &&
      this.$refs.serviceZoneAdsSwiper.swiper.autoplay &&
      this.$refs.serviceZoneAdsSwiper.swiper.autoplay.stop()
  },
  activated() {
    this.$refs.serviceZoneAdsSwiper &&
      this.$refs.serviceZoneAdsSwiper.swiper &&
      this.$refs.serviceZoneAdsSwiper.swiper.autoplay &&
      this.$refs.serviceZoneAdsSwiper.swiper.autoplay.start()
  },

  methods: {
    ...mapActions(["reportAndJump", "reportUserAction"]),
    // 跳转到活动页
    jumpToBuyPage(index) {
      if (this.jumpToBuyPageFunc) {
        this.jumpToBuyPageFunc(index)
      } else {
        this.jumpToActivityPage({
          activityConfig: this.shelfConfig,
          index: index,
          iformat: reportDict.CLICK.GAME_ZONE_LIST_ADS_BANNER,
          pfStructure: this.pfStructure || "gamepage_banner"
        })
      }
    }
  }
}
</script>

<style scoped>
/* 设置无遮罩 */
.list-top-banner-info.no-mask::before {
  opacity: 0;
}
.list-top-banner-info.origin-mask::before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  opacity: 0.32;
  border-radius: 0.08rem;
  background-image: linear-gradient(90deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.1) 83%);
}
</style>
